export default __webpack_public_path__ + "static/media/reason01.11492796.jpg";